import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { getWishlist } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/selectors';
import { WishlistDetailedType } from 'b2b-common/core/account/api/wishlists';

type UseWishlistReturnType = RemoteRecord<WishlistDetailedType>;

const useWishlist = (wishlistId: string): UseWishlistReturnType => (
  useSelector((state: State) => getWishlist(state, wishlistId))
);

export type { UseWishlistReturnType };
export { useWishlist };
